import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { translationEN } from './en';
import { translationJA } from './ja';
import { translationVI } from './vi';
import { translationAR } from './ar';
import { translationHI } from './hi';
import { translationFR } from './fr';
import { translationZH } from './zh';
import { translationKO } from './ko';
import { translationPT } from './pt';
import { translationES } from './es';

// Các tệp ngôn ngữ
const resources = {
  en: { translation: translationEN },
  ja: { translation: translationJA },
  vi: { translation: translationVI },
  ar: { translation: translationAR },
  hi: { translation: translationHI },
  fr: { translation: translationFR },
  zh: { translation: translationZH },
  ko: { translation: translationKO },
  pt: { translation: translationPT },
  es: { translation: translationES },
};

i18n
  .use(initReactI18next) // Kết nối với react-i18next
  .init({
    resources,
    lng: 'en', // Ngôn ngữ mặc định
    fallbackLng: 'en', // Ngôn ngữ dự phòng
    interpolation: {
      escapeValue: false, // React tự xử lý XSS
    },
  });

export default i18n;
